import { createSelector, createStructuredSelector } from 'reselect'

import { locationSelector } from 'state/routes'
import { accountSelector } from '../App/selectors'

export const componentSelector = createSelector(
  locationSelector,
  location => location.routesMap[location.type].component,
)

export const idSelector = createSelector(
  locationSelector,
  location => location.routesMap[location.type].id,
)

export const pageTypeSelector = createSelector(
  locationSelector,
  location => location.routesMap[location.type].pageType,
)

export const footerlessSelector = createSelector(
  locationSelector,
  location => location.routesMap[location.type].footerless,
)

export const isLoadingSelector = createSelector(
  locationSelector,
  state => state,
  (location, state) =>
    location.routesMap[location.type].isLoading &&
    location.routesMap[location.type].isLoading(state),
)

export const errorSelector = createSelector(
  locationSelector,
  state => state,
  (location, state) =>
    location.routesMap[location.type].getError &&
    location.routesMap[location.type].getError(state),
)

export default createStructuredSelector({
  id: idSelector,
  component: componentSelector,
  isLoading: isLoadingSelector,
  error: errorSelector,
  pageType: pageTypeSelector,
  footerless: footerlessSelector,
  account: accountSelector,
})



// WEBPACK FOOTER //
// ../source/views/Switch/selectors.js